import Image from "next/image"
import React from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, Button, Loader } from "visuais"

interface PreviewFile {
  url: string
  name: string
  type: string
}

interface FilePreviewModalProps {
  files: PreviewFile[]
  isOpen: boolean
  onClose: () => void
  loading: boolean
}

export function FilePreviewModal({ files, isOpen, onClose, loading }: FilePreviewModalProps) {
  const [index, setIndex] = React.useState(0)

  React.useEffect(() => {
    if (!isOpen) return
    setIndex(0)
  }, [isOpen, files])

  if (loading) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="flex items-center justify-center min-w-[40vw] h-[40vh]">
          <DialogHeader className="sr-only">
            <DialogTitle className="sr-only">Anexos</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center gap-2 min-h-[40vh]">
            <Loader size={96}/>
            <span className="text-muted-foreground">Carregando anexos...</span>
          </div>
        </DialogContent>
      </Dialog>
    )
  }

  const current = files[index]
  const fileTypeLower = current?.type?.toLowerCase?.() || ""
  const isPdf = fileTypeLower === "application/pdf" || fileTypeLower.endsWith("/pdf") || current?.name?.toLowerCase?.().endsWith(".pdf")
  const isImage = ["png", "jpg", "jpeg", "webp", "gif"].some((ext) => fileTypeLower.includes(ext) || current?.name?.toLowerCase?.().endsWith(`.${ext}`))

  const prev = () => setIndex((i) => (i - 1 + files.length) % files.length)
  const next = () => setIndex((i) => (i + 1) % files.length)

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="min-w-[60vw] h-[90vh]">
        <DialogHeader className="sr-only">
          <DialogTitle className="sr-only">Anexos</DialogTitle>
        </DialogHeader>

        {current && (
          <div className="relative h-full flex flex-col gap-2">
            <div className="flex-1 overflow-hidden">
              {isImage && (
                <Image src={current.url} alt={current.name} className="h-full mx-auto" />
              )}

              {isPdf && (
                <iframe
                  src={current.url}
                  className="w-full h-full border"
                  title={current.name}
                />
              )}
            </div>

            {/* Navegação e contador no rodapé */}
            <div className="flex items-center justify-between text-sm text-muted-foreground">
              {files.length > 1 && (
                <span className="absolute bottom-2 left-2">
                  {index + 1} de {files.length}
                </span>
              )}
              {files.length > 1 && (
                <div className="flex items-center justify-end gap-2 ml-auto">
                  <Button size="sm" variant="ghost" onClick={prev}>
                    Anterior
                  </Button>
                  <Button size="sm" variant="ghost" onClick={next}>
                    Próximo
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
